  <div class="distributions-container px-4 py-3">

    <!-- Page Header -->
    <div class="mb-4">
      <h2 class="fw-bold mb-1">Distributions</h2>
      <p class="text-dark mb-0">
        View your personal distribution history and statements.
      </p>
    </div>

    <!-- Summary Cards -->
    <div class="row g-4 mb-4">

      <!-- Total Received -->
      <div class="col-md-4">
        <div class="glassy-table shadow-sm border-0 rounded-lg p-3 h-100">
          <p class="text-dark small mb-2">Total Received</p>
          <h3 class="fw-bold mb-1">R 58 350</h3>
          <p class="text-success small mb-0">
            <i class="bx bx-trending-up me-1"></i>
            +12.5% YoY
          </p>
        </div>
      </div>

      <!-- Next Distribution -->
      <div class="col-md-4">
        <div class="glassy-table shadow-sm border-0 rounded-lg p-3 h-100">
          <p class="text-dark small mb-2">Next Distribution</p>
          <h3 class="fw-bold mb-1">15 Mar 2025</h3>
          <p class="text-dark small mb-0">
            Estimated: R 17 200
          </p>
        </div>
      </div>

      <!-- Payment Frequency -->
      <div class="col-md-4">
        <div class="glassy-table shadow-sm border-0 rounded-lg p-3 h-100">
          <p class="text-dark small mb-2">Payment Frequency</p>
          <h3 class="fw-bold mb-1">Quarterly</h3>
          <p class="text-dark small mb-0">
            March, June, September, December
          </p>
        </div>
      </div>

    </div>

    <!-- Distribution History Card -->
    <div class="glassy-table shadow-sm border-0 rounded-lg p-4">

      <div class="mb-4">
        <h4 class="fw-bold mb-1">Distribution History</h4>
        <p class="text-dark small mb-0">
          Your personal distribution records
        </p>
      </div>

      <!-- Bootstrap Table -->
      <div class="table-responsive">
        <table class="table align-middle mb-0">

          <thead class="border-bottom">
            <tr class="text-dark text-xs fw-semibold">
              <th>Date</th>
              <th>Reference</th>
              <th>Status</th>
              <th>Amount</th>
              <th></th>
            </tr>
          </thead>

          <tbody>
            <tr
              v-for="item in history"
              :key="item.id"
              class="border-bottom"
            >

              <!-- Date -->
              <td class="fw-semibold text-xs">
                <i class="bx bx-calendar me-2 text-dark"></i>
                {{ item.date }}
              </td>

              <!-- Reference -->
              <td class="text-dark text-xs">
                {{ item.reference }}
              </td>

              <!-- Status -->
              <td class="text-xs">
                <span
                  class="badge rounded-pill px-3 py-2 border"
                  :class="statusBadgeClass(item.status)"
                >
                  {{ item.status }}
                </span>

                <div
                  v-if="item.status === 'Missed'"
                  class="small text-dark mt-1"
                >
                  KYC incomplete
                </div>
              </td>

              <!-- Amount -->
              <td class="fw-bold text-xs">
                R {{ formatAmount(item.amount) }}
              </td>

              <!-- Action -->
              <td class="text-end">
                <button
                  v-if="item.amount > 0"
                  class="d-none btn btn-sm btn-primary-dark text-xs text-dark p-1"
                >
                 view
                </button>
              </td>

            </tr>
          </tbody>

        </table>
      </div>

      <div class="alert alert-success border-0 d-flex justify-content-between align-items-center mt-3 shadow-sm">
          <div class="d-flex align-items-center gap-3">
            <i class="bi bi-wallet fs-4 text-success"></i>
            <div>
              <strong class="d-block text-xs">Banking Details</strong>
              <span class="text-xs">
                Distributions are paid to your verified bank account. Ensure your banking details are up to date in your profile to avoid payment delays.
              </span>
            </div>
          </div>
          <button class="btn-close"></button>
        </div>

    </div>

  </div>